<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
 <footer class="crm-footer">
  © {{ new Date().getFullYear() }} BP-CRM · {{ t('common.all_rights_reserved') }}
 </footer>
</template>
